import {
  IClearParticipantsResourcesAction,
  ICycleParticipantsReduxState,
  IGetParticipantsResourcesAction,
  IGetParticipantsResourcesActionFulfilled,
  IGetParticipantsResourcesActionRejected
} from "../../types";

const initialState: ICycleParticipantsReduxState = {
  completedResources: false,
  cycle: null,
  filterReferences: null,
  pendingResources: false,
  rejectedResources: false
};

type Actions =
  | IGetParticipantsResourcesAction
  | IGetParticipantsResourcesActionFulfilled
  | IGetParticipantsResourcesActionRejected
  | IClearParticipantsResourcesAction;

export default (state = initialState, action: Actions): ICycleParticipantsReduxState => {
  switch (action.type) {
    case "CLEAR_PARTICIPANTS_RESOURCES":
      return {
        ...state,
        completedResources: false,
        cycle: null,
        filterReferences: null,
        pendingResources: true,
        rejectedResources: false
      };
    case "GET_PARTICIPANTS_RESOURCES":
      return {
        ...state,
        completedResources: false,
        cycle: null,
        filterReferences: null,
        pendingResources: true,
        rejectedResources: false
      };
    case "GET_PARTICIPANTS_RESOURCES_REJECTED":
      return {
        ...state,
        completedResources: true,
        cycle: null,
        filterReferences: null,
        pendingResources: false,
        rejectedResources: true
      };
    case "GET_PARTICIPANTS_RESOURCES_FULFILLED":
      const { cycle, filterReferences } = action.payload;
      return {
        ...state,
        completedResources: true,
        cycle,
        filterReferences,
        pendingResources: false,
        rejectedResources: false
      };
    default:
      return {
        ...state
      };
  }
};
